import { render } from "./PatientAnketaModal.vue?vue&type=template&id=032e283d&scoped=true"
import script from "./PatientAnketaModal.vue?vue&type=script&lang=js"
export * from "./PatientAnketaModal.vue?vue&type=script&lang=js"

import "./PatientAnketaModal.vue?vue&type=style&index=0&id=032e283d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032e283d"]])

export default __exports__